export default __webpack_public_path__ + "static/media/woman-laptop.a2098dcf.svg";